/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BookingType from './booking-type';
import BookingTypeDetail from './booking-type-detail';
import BookingTypeUpdate from './booking-type-update';
import BookingTypeDeleteDialog from './booking-type-delete-dialog';

const BookingTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BookingType />} />
    <Route path="new" element={<BookingTypeUpdate />} />
    <Route path=":id">
      <Route index element={<BookingTypeDetail />} />
      <Route path="edit" element={<BookingTypeUpdate />} />
      <Route path="delete" element={<BookingTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BookingTypeRoutes;
